import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Gmap from './Gmap';
import Select from 'react-select';
import Slider from '@mui/material/Slider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {
  homeTypeOptions,
  unitTypeOptions,
  propertyFeaturesOptions,
  rentalPropertyFeaturesOptions,
} from '../contants/data';
// ICONS
import { GrPowerReset } from 'react-icons/gr';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';

const Filters = ({ onFilter, data, stateCategory, filters }) => {
  const [thunks, setThunks] = useState(null);
  const [showAdvFilter, setShowAdvFilter] = useState(false);
  const { isFilter } = useSelector((state) => state[stateCategory]);
  const dispatch = useDispatch();

  // GEOLOCATE
  const { lat, lng, radius } = useSelector(
    (state) => state[stateCategory].filters.location
  );

  // NEW LAT,LNG
  const [newLat, setNewLat] = useState('');
  const [newLng, setNewLng] = useState('');

  // PRICE
  const { min: priceMin, max: priceMax } = useSelector(
    (state) => state[stateCategory].filters.price_range
  );
  const [priceVal, setPriceVal] = useState([priceMin, priceMax]);
  const handlePriceChange = (event, newValue) => {
    setPriceVal(newValue);
    dispatch(thunks?.changePrice({ min: newValue[0], max: newValue[1] }));
  };

  // BEDS
  const { min: bedsMin, max: bedsMax } = useSelector(
    (state) => state[stateCategory].filters.beds_range
  );
  const [bedsVal, setBedsVal] = useState([bedsMin, bedsMax]);
  const handleBedsChange = (event, newValue) => {
    setBedsVal(newValue);
    dispatch(thunks?.changeBeds({ min: newValue[0], max: newValue[1] }));
  };

  // SLEEPS
  const { min: sleepsMin, max: sleepsMax } = useSelector(
    (state) => state[stateCategory].filters.sleeps_range
  );
  const [sleepsVal, setSleepsVal] = useState([sleepsMin, sleepsMax]);
  const handleSleepsChange = (event, newValue) => {
    setSleepsVal(newValue);
    dispatch(thunks?.changeSleeps({ min: newValue[0], max: newValue[1] }));
  };

  // BATHS
  const { min: bathsMin, max: bathsMax } = useSelector(
    (state) => state[stateCategory].filters.baths_range
  );
  const [bathsVal, setBathsVal] = useState([bathsMin, bathsMax]);
  const handleBathsChange = (event, newValue) => {
    setBathsVal(newValue);
    dispatch(thunks?.changeBaths({ min: newValue[0], max: newValue[1] }));
  };

  // SIZE SQFT
  const { min: sizeSqFtMin, max: sizeSqFtMax } = useSelector(
    (state) => state[stateCategory].filters.size_sqft_range
  );
  const [sizeSqFtVal, setSizeSqFtVal] = useState([sizeSqFtMin, sizeSqFtMax]);
  const handleSizeSqFtChange = (event, newValue) => {
    setSizeSqFtVal(newValue);
    dispatch(thunks?.changeSizeSqFt({ min: newValue[0], max: newValue[1] }));
  };

  // HOME TYPE
  const { homeType } = useSelector((state) => state[stateCategory].filters);
  const [selectedHomeType, setSelectedHomeType] = useState([]);
  const handleHomeTypeChange = (options) => {
    setSelectedHomeType(options ? options.map((option) => option.value) : []);
    dispatch(
      thunks?.changeHomeType(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // UNIT TYPE
  const { unitType } = useSelector((state) => state[stateCategory].filters);
  const [selectedUnitType, setSelectedUnitType] = useState([]);
  const handleUnitTypeChange = (options) => {
    setSelectedUnitType(options ? options.map((option) => option.value) : []);
    dispatch(
      thunks?.changeUnitType(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // PROPERTY FEATURES
  const { propertyFeatures } = useSelector(
    (state) => state[stateCategory].filters
  );
  const [selectedPropertyFeatures, setSelectedPropertyFeatures] = useState([]);
  const handlePropertyFeaturesChange = (options) => {
    setSelectedPropertyFeatures(
      options ? options.map((option) => option.value) : []
    );
    dispatch(
      thunks?.changePropertyFeatures(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // RENTAL PROPERTY FEATURES
  const { rentalPropertyFeatures } = useSelector(
    (state) => state[stateCategory].filters
  );
  const [selectedRentalPropertyFeatures, setSelectedRentalPropertyFeatures] =
    useState([]);
  const handleRentalPropertyFeaturesChange = (options) => {
    setSelectedRentalPropertyFeatures(
      options ? options.map((option) => option.value) : []
    );
    dispatch(
      thunks?.changeRentalPropertyFeatures(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  useEffect(() => {
    const loadThunks = async () => {
      let importedThunks;
      if (stateCategory === 'housingForSale') {
        importedThunks = await import('../store/slices/housingForSale.slice');
      } else if (stateCategory === 'longTermHousingRentals') {
        importedThunks = await import(
          '../store/slices/longTermHousingRentals.slice'
        );
      } else if (stateCategory === 'shortTermHousingRentals') {
        importedThunks = await import(
          '../store/slices/shortTermHousingRentals.slice'
        );
      }

      setThunks(importedThunks);
    };

    loadThunks();
  }, [stateCategory]);

  if (!thunks) {
    return <div>Loading...</div>;
  }

  const handleSubmit = () => {
    let finalLat = '';
    let finalLng = '';
    if ((newLat != '') & (newLng != '')) {
      finalLat = newLat;
      finalLng = newLng;
      dispatch(thunks?.changeLocation({ lat: finalLat, lng: finalLng }));
    } else {
      finalLat = lat;
      finalLng = lng;
    }

    onFilter({
      finalLat,
      finalLng,
      radius,
      priceVal,
      bedsVal,
      sleepsVal,
      bathsVal,
      sizeSqFtVal,
      homeType,
      unitType,
      propertyFeatures,
      rentalPropertyFeatures,
    });
    dispatch(thunks?.activateFilter(true));
    dispatch(thunks?.setSearchTerm(''));
    dispatch(thunks?.setSortBy('Closest to Me'));
    dispatch(thunks?.resetSortedData());
  };

  const updateLoc = (lat, lng) => {
    setNewLat(() => {
      return lat;
    });
    setNewLng(() => {
      return lng;
    });
  };

  const handleResetFilter = () => {
    window.location.reload();
  };

  return (
    <div className='sidebar hide-mobile'>
      <Gmap onChangeLoc={updateLoc} data={data} />
      {filters.includes('Price') && (
        <div className='form-control-wrap'>
          <label>Price</label>
          <Slider
            value={priceVal}
            onChange={handlePriceChange}
            valueLabelDisplay='auto'
            max={5000000}
            step={1000}
          />
          <div className='price-range-wrap'>
            <span>${priceVal[0].toLocaleString('en-US')} - </span>
            <span>${priceVal[1].toLocaleString('en-US')}</span>
          </div>
        </div>
      )}
      {filters.includes('Beds') && (
        <div className='form-control-wrap'>
          <label>Beds</label>
          <Slider
            value={bedsVal}
            onChange={handleBedsChange}
            valueLabelDisplay='auto'
            max={20}
            step={1}
          />
          <div className='price-range-wrap'>
            <span>{bedsVal[0].toLocaleString('en-US')} - </span>
            <span>{bedsVal[1].toLocaleString('en-US')}</span>
          </div>
        </div>
      )}
      {filters.includes('Sleeps') && (
        <div className='form-control-wrap'>
          <label>Sleeps</label>
          <Slider
            value={sleepsVal}
            onChange={handleSleepsChange}
            valueLabelDisplay='auto'
            max={20}
            step={1}
          />
          <div className='price-range-wrap'>
            <span>{sleepsVal[0].toLocaleString('en-US')} - </span>
            <span>{sleepsVal[1].toLocaleString('en-US')}</span>
          </div>
        </div>
      )}
      {filters.includes('Baths') && (
        <div className='form-control-wrap'>
          <label>Baths</label>
          <Slider
            value={bathsVal}
            onChange={handleBathsChange}
            valueLabelDisplay='auto'
            max={20}
            step={1}
          />
          <div className='price-range-wrap'>
            <span>{bathsVal[0].toLocaleString('en-US')} - </span>
            <span>{bathsVal[1].toLocaleString('en-US')}</span>
          </div>
        </div>
      )}
      {filters.includes('Size_sqft') && (
        <div className='form-control-wrap'>
          <label>Size (SQ. FT.)</label>
          <Slider
            value={sizeSqFtVal}
            onChange={handleSizeSqFtChange}
            valueLabelDisplay='auto'
            max={100000}
            step={10}
          />
          <div className='price-range-wrap'>
            <span>{sizeSqFtVal[0].toLocaleString('en-US')} - </span>
            <span>{sizeSqFtVal[1].toLocaleString('en-US')}</span>
          </div>
        </div>
      )}
      {filters.includes('Home Type') && (
        <div className='form-control-wrap'>
          <label>Home Type</label>
          <Select
            isMulti
            options={homeTypeOptions}
            onChange={handleHomeTypeChange}
            value={homeTypeOptions.filter((option) =>
              selectedHomeType.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}
      {filters.includes('Unit Type') && (
        <div className='form-control-wrap'>
          <label>Unit Type</label>
          <Select
            isMulti
            options={unitTypeOptions}
            onChange={handleUnitTypeChange}
            value={unitTypeOptions.filter((option) =>
              selectedUnitType.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}
      {filters.includes('Property Features') && (
        <div className='form-control-wrap'>
          <label>Property Features</label>
          <Select
            isMulti
            options={propertyFeaturesOptions}
            onChange={handlePropertyFeaturesChange}
            value={propertyFeaturesOptions.filter((option) =>
              selectedPropertyFeatures.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}
      {filters.includes('Rental Property Features') && (
        <div className='form-control-wrap'>
          <label>Rental Property Features</label>
          <Select
            isMulti
            options={rentalPropertyFeaturesOptions}
            onChange={handleRentalPropertyFeaturesChange}
            value={rentalPropertyFeaturesOptions.filter((option) =>
              selectedRentalPropertyFeatures.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}
      <button onClick={() => handleSubmit()} className='primary mb-10'>
        Filter
      </button>
      <button
        onClick={() => handleResetFilter()}
        className='reset'
        disabled={!isFilter}
      >
        Reset Filter
      </button>
    </div>
  );
};

export default Filters;
